import {MinifiedArgument} from "../core/models/minified-argument.model";
import { QueryFilterParameter } from "../widgets/filters/models/query-filter-parameter.model";
import { MinifiedSelection } from "../widgets/minified-selections/models/minified-selection-model";

export class Utils {

	public static nameof<T>(obj: T, expression: (x: { [Property in keyof T]: () => string }) => () => string): string {
			const result: { [Property in keyof T]: () => string } = {} as { [Property in keyof T]: () => string };

			Object.keys(obj).map(k => result[k as keyof T] = () => k);

			return expression(result)();
	}
}

export class StringUtils {

	public static readonly isUpperCase = (value: string) => /^[A-Z]*$/.test(value);

	public static toDisplayString(value: string): string {
		if (!value)
			return value;

		let stringBuilder: string[] = [];

		stringBuilder.push(value[0]);

		for (let i = 1; i < value.length; i++)
		{
			if (StringUtils.isUpperCase(value[i]) && value[i - 1] != ' ')
				stringBuilder.push(' ');
			stringBuilder.push(value[i]);
		}

		return stringBuilder.join("");
	}
}

export class ColorUtils {

	public static lerpColor(a, b, t): string {

		let ah = parseInt(a.replace(/#/g, ''), 16),
				ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
				bh = parseInt(b.replace(/#/g, ''), 16),
				br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
				rr = ar + t * (br - ar),
				rg = ag + t * (bg - ag),
				rb = ab + t * (bb - ab);

		return '#' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
	}
}

export class FilterUtils {

	public static convertFiltersOutputToURLQuery(filtersOutput: QueryFilterParameter[]): string {
		let query = "";

		if (filtersOutput) {
			for (let a = 0; a < filtersOutput.length; a++) {
				const filtersOptions = filtersOutput[a];

				query += `&filters.filters[${a}].fieldName=${filtersOptions.fieldName}&filters.filters[${a}].value=${filtersOptions.value}&filters.filters[${a}].operation=${filtersOptions.operation}`;
			}
		}

		return query;
	}

	public static convertFiltersToURLQuery(filters: QueryFilterParameter[], includeAmpersand: boolean = true): string {
		let query: string = "";

		for (let a = 0; a < filters.length; a++) {
			const filter = filters[a];

			query += `${includeAmpersand ? '&' : ''}filters[${a}].fieldName=${encodeURIComponent(filter.fieldName)}&filters[${a}].value=${encodeURIComponent(filter.value)}&filters[${a}].operation=${encodeURIComponent(filter.operation)}`;
		}

		return query;
	}
}

export class MinifiedArgumentUtils {

	public static convertToURLQuery(minifiedArguments: MinifiedArgument[]): string {
		let query: string = "";

		for (let a = 0; a < minifiedArguments.length; a++) {
			query += `${a > 0 ? '&' : ''}minifiedArguments[${a}].name=${minifiedArguments[a].name}&minifiedArguments[${a}].valueType=${minifiedArguments[a].valueType}&minifiedArguments[${a}].value=${minifiedArguments[a].value}`;
		}

		return query;
	}
}

export class MinifiedSelectionUtils {

	public static convertToURLQuery(minifiedSelections: MinifiedSelection[]): string {
		let query: string = "";

		for (let a = 0; a < minifiedSelections.length; a++) {
			query += `${a > 0 ? '&' : ''}minifiedSelections[${a}].selectionName=${minifiedSelections[a].selectionName}&minifiedSelections[${a}].isVisible=${minifiedSelections[a].isVisible}&minifiedSelections[${a}].orderBy=${minifiedSelections[a].orderBy}&minifiedSelections[${a}].aggregateFunctionId=${minifiedSelections[a].aggregateFunctionId ?? ""}`;
		}

		return query;
	}
}
